export default __webpack_public_path__ + "static/media/qr-code_rose_lizard.cbca3607.png";